// extracted by mini-css-extract-plugin
export default {"container":"UserInfo_container__bR2S4","barContainer":"UserInfo_barContainer__joePA"};